import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import ToastHandler from '../../components/toasthandler';
import Loader from '../../components/loader';
import Modal from '../../components/modal';

import {
  updateUser,
  fetchMe,
  fetchSecurity
} from '../../actions';

class DeviceWhitelist extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalComponent: null,
      wideModal: false,
      deviceWhitelisting: false,
    };
  }

  componentDidMount() {
    const { user, dispatch } = this.props;
    let deviceWhitelisting;
    if (user && user.me && user.me.flags && user.me.flags.deviceWhitelisting) {
      deviceWhitelisting = user.me.flags.deviceWhitelisting;
    }

    this.setState({deviceWhitelisting})
    dispatch(fetchSecurity());
  }

  handleDeviceWhitelistChange() {
    const { dispatch, user } = this.props;
    const { deviceWhitelisting } = this.state;

    const data = {
      deviceWhitelisting: !deviceWhitelisting
    }

    dispatch(updateUser(data)).then((res) => {
      if (res) dispatch(fetchMe());
    });

    this.setState({ deviceWhitelisting: !deviceWhitelisting, pristine: true });
  }

  render() {
    const { user, errors, success } = this.props;
    const { deviceWhitelisting } = this.state;

    let otpEnabled;
    let yubiEnabled;
    if (user.security) {
      const otpHandle = user.security.find(e => e.typeHandle === 'OTP');
      if (otpHandle && otpHandle.statusHandle === 'ACTIVATED') {
        otpEnabled = true;
      }
      const yubiHandle = user.security.find(e => e.typeHandle === 'YUBIKEY');
      if (yubiHandle && yubiHandle.statusHandle === 'ACTIVATED') {
        yubiEnabled = true;
      }
    }

    let enabled2fa;
    if (otpEnabled || yubiEnabled) {
      enabled2fa = true;
    }

    let globalSettingsLock;
    if (user && user.me && user.me.flags && user.me.flags.globalSettingsLock) {
      globalSettingsLock = user.me.flags.globalSettingsLock;
    }

    if (!user.security) {
      return (
        <div className="center-loader">
          <Loader logo />
        </div>
      );
    }

    return (
      <div className="grid-x">
        <ToastHandler errors={errors} success={success} />
        <div className="cell small-12 medium-12 large-12" style={{marginBottom: 20}}>
          <a className="backlink" href="/settings">
            <FontAwesomeIcon
              size="sm"
              icon={faChevronLeft}
            />
            &nbsp;
            Back to Settings
          </a>
        </div>
        <div className="cell panel v2 small-12 medium-12 large-12">
          <div className="panel-label">
            Security
          </div>
          <hr />
          <div className="grid-x align-middle">
            <div className="cell small-6 medium-6 large-6">
              Device Whitelisting
            </div>
            <div className="cell small-6 medium-6 large-6 flex-end">
              <div
                onClick={() => this.handleDeviceWhitelistChange()}
                className={deviceWhitelisting ? 'vlt-switch on' : 'vlt-switch off'}
              >
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  errors: state.user.errors,
  success: state.user.success,
});

export default connect(mapStateToProps)(DeviceWhitelist);
